<template>
  <Marker :options="options" @click="onClick">
    <InfoWindow ref="infoWindowRef" :options="infoWindowOptions" v-if="renderInfoWindow">
      <EcoEventsInfo :description="description" :data="infoOptions" />
    </InfoWindow>
  </Marker>
</template>

<script>
import {InfoWindow, Marker} from "vue3-google-map";
import EcoEventsInfo from "@/components/pages/EcoEventsInfo.vue";
import markerIcon from "@/assets/images/reports/fuelpump-marker.png";
import {dataManipulator} from "@/assets/js/data-manipulation";

export default {
  name: "RefuelMarker",
  components: {InfoWindow, EcoEventsInfo, Marker},
  props: {
    data: {
      type: Object,
      required: true
    },
    infoWindowHeader: {
      type: Object,
      required: true
    },
    openInfoOnClick: {
      type: Boolean,
      default: true
    },
    customOptions: Object,
  },
  emits: ['click'],
  data() {
    return {
      renderInfoWindow: false
    };
  },
  computed: {
    options() {
      return {
        ...{
          position: this.position,
          icon: markerIcon,
        },
        ...this.customOptions
      };
    },
    infoWindowOptions() {
      return {
        position: this.position,
        headerContent: this.infoWindowHeader
      };
    },
    infoOptions() {
      return {
        address: this.address,
        refuel: this.refuel,
        time: this.time,
      }
    },
    position() {
      return {lat: this.data.latitude, lng: this.data.longitude};
    },
    address() {
      return `${this.data.latitude}, ${this.data.longitude}`;
    },
    time() {
      const data = dataManipulator.iso8601DateStringToLocalMoment(this.data.info.timestamp.date);
      return data !== null ? data.format(this.$t('settings.generic.date-time-format-moment')) : ''
    },
    refuel() {
      return this.data.totalRefuelLiters;
    },
    description() {
      return this.$t('reports.trips.result.refuel');
    }
  },
  methods: {
    onClick() {
      this.$emit('click', this);
      if (this.openInfoOnClick) {
        this.showInfoWindow();
      }
    },
    showInfoWindow() {
      this.renderInfoWindow = true;
      setTimeout(() => this.$refs.infoWindowRef?.open(), 10);
    },
    closeInfoWindow() {
      this.$refs.infoWindowRef?.close();
      this.renderInfoWindow = false;
    },
    isInfoWindowOpen() {
      return this.$refs.infoWindowRef?.infoWindow.isOpen;
    }
  }
}
</script>

<style scoped lang="scss">

</style>